import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const BillsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "Bills" */
      '../../../components/Treasury/Bills/Bills'
    ),
  teamOwner: 'treasury',
  sentryTeam: 'treasury_surfaces',
  releaseState: 'internal',
  description: 'A list of bills for a connected account.',
  friendlyName: 'Bills',
  enableV2APIToken: true,
};
